import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { WhatsAppIcon } from "@/components/ShareButtons";

export default function FloatingWhatsApp() {
  const { pathname } = useLocation();
  const { data: settings } = useQuery({
    queryKey: ["settings"],
    queryFn: async () => (await api.get("/settings")).data,
  });
  const phone = (settings?.phone || "").replace(/[^\d]/g, "");
  if (!phone) return null;

  const msg = encodeURIComponent("Hi Planet Trotter Foundation, I'd like to know more about your work and journeys.");

  return (
    <motion.a
      href={`https://wa.me/${phone}?text=${msg}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      data-testid="floating-whatsapp"
      key={pathname}
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1, duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
      className="fixed bottom-5 right-5 z-40 grid h-13 w-13 place-items-center rounded-full bg-[#1FA855] text-white shadow-[0_6px_24px_rgba(18,140,75,0.45)] hover:bg-[#128C4B] hover:scale-105 transition-[background-color,transform] duration-300"
      style={{ height: "52px", width: "52px" }}
    >
      <WhatsAppIcon className="h-6 w-6" />
    </motion.a>
  );
}
